/* app/js/src/components/user/common/user-form/user-channel-permissions/user-channel-permissions.component.scss */
.preloader {
  font-size: 36px;
  text-align: center;
  min-height: 495px;
  line-height: 495px;
}
.channel-permissions {
  width: 90%;
  border-collapse: collapse;
  margin-left: 5%;
  margin-right: 5%;
  margin-bottom: 5%;
  color: #879baf;
  text-align: center;
}
.channel-permissions .button {
  cursor: pointer;
}
.channel-permissions thead {
  position: sticky;
  top: -15px;
  background: white;
  z-index: 2;
  border-bottom: 2px solid #ccc;
}
.channel-permissions tbody tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.channel-permissions tr td:first-child,
.channel-permissions tr th:first-child {
  text-align: left;
}
.channel-permissions tr td,
.channel-permissions tr th {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 18%;
}
/*# sourceMappingURL=user-channel-permissions.component.css.map */
